import React from "react";
import { INPUT_INFO_ICON, TENDERPDFICON_IMG } from "../../utils/app-image-contant";
import { Tooltip } from "react-tooltip";
import { docName, openPdfFile } from "../../utils/utilities";

const Input = ({
  lableName = "Name",
  typeName = "text",
  placeholder = "",
  Name = "name",
  value = "",
  mandatory = true,
  error = false,
  info_Icon = false,
  pdf_Icon = false,
  disabled = false,
  handleChange = function o() { },
  tooltipdata = "hello",
  id = "",
  tooltipContent = "",
  textForUserinfo = "",
  maxLength = "40",
  className = "",
  customHeight = "",
  accsessablityId = "",
  lebalClass = "",
  inputClassName=""
}) => {
  const handlePdfIcon = (value) => {
    openPdfFile(value);
  };

  let nameArr = ["nameOfApplicant", "nameOfOrganization", "houseNo", "city", "govtPresmisesAuthority", "kendraHouseNo", "kendraCity","pharmacistName","registrationNo","gstNumber",]
  const handleKeyPress = (event) => {
    if (nameArr?.includes(Name)) {
      if (!/^[a-zA-Z0-9\s]*$/.test(event.key)) {
        event.preventDefault(); // Prevent invalid input
      }
    }
  };

  return (
    <>
      <label for="exampleInput" id={accsessablityId} className="form-label labelText">
        {lableName}
      </label>{" "}
      <span className="textForUserinfo">
        {textForUserinfo && `(${textForUserinfo})`}
        {mandatory && <span className="text-red">*</span>}
      </span>
      <div className={`input-relative ${className}`}>
        <input
          type={typeName}
          className={`form-control inputText ${customHeight} ${inputClassName} ${error && "border-danger bg-error"
            }`}
          name={Name}
          maxLength={maxLength}
          placeholder={placeholder}
          onKeyPress={handleKeyPress}
          value={pdf_Icon ? docName(value) : value}
          disabled={disabled}
          onChange={handleChange}
        />
        {info_Icon && (
          <>
            <a
              data-tooltip-id={id}
              data-tooltip-content={tooltipContent}
              data-tooltip-place="top"
              className="tooltip-content"
            >
              <img
                src={INPUT_INFO_ICON}
                className="input-right-icon"
                alt="info-icon"
                width="18px"
              />
            </a>
            <Tooltip id={id} className="example-pink" />
          </>
        )}

        {pdf_Icon && (
          <img
            type="button"
            src={TENDERPDFICON_IMG}
            className="input-pdf-right-icon"
            alt="info-icon"
            onClick={() => handlePdfIcon(value)}
            width="30px"
          />
        )}
      </div>
    </>
  );
};

export default Input;
